import React, {useCallback, useState} from 'react';
import type {ButtonProps} from '@mui/material';
import {Button} from '@mui/material';

export type ActionButtonV2Props = Omit<ButtonProps, 'onClick'> & {
  onClick: () => Promise<void> | void;
  showSpinnerOnClick?: boolean;
};

export const ActionButtonV2: React.FC<ActionButtonV2Props> = ({
  showSpinnerOnClick,
  onClick,
  ...rest
}) => {
  const [handlingClick, setHandlingClick] = useState<boolean>(false);
  const handleClick = useCallback(() => {
    setHandlingClick(true);
    Promise.resolve(onClick()).finally(() => setHandlingClick(false));
  }, [onClick]);

  const busy = showSpinnerOnClick ? handlingClick : undefined;

  return <Button {...rest} onClick={handleClick} loading={busy} />;
};
